export const styles = {
	saveButtonBox: {
		display: 'flex',
		flexDirection: {
			xs: 'column',
			sm: 'row',
		},
		gap: '2rem',
	},
	editButtonBox: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'end',
	},
	editPromptsBox: {
		display: 'flex',
		gap: '2rem',
	},
	editPromptsMode: {
		'.MuiInputBase-input': {
			fontWeight: '500',
			color: 'rgba(0, 0, 0, 0.87)',
			fontSize: {
				xs: 16,
				sm: 20,
			},
		},
		'.MuiOutlinedInput-notchedOutline': {
			border: 'none',
		},
		'.MuiOutlinedInput-root': {
			borderRadius: '0',
			borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
			backgroundColor: '#FFFFFF',
		},
		flexDirection: {
			xs: 'column',
			sm: 'row',
		},
	},
	mainBox: {
		display: 'flex',
	},
	marginRightBox: {
		marginRight: '2rem',
	},
	paper: {
		padding: '1rem',
		backgroundColor: '#F5F5F5',
		overflow: 'hidden',
		color: 'black',
	},
	image: {
		width: '100%',
		aspectRatio: '3 / 2',
		objectFit: 'contain',
		display: 'block',
	},
	techniqueBox: {
		'white-space': 'pre-line',
	},
	refreshButtonBox: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'end',
		alignItems: 'center',
		gap: '1rem',
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		alignSelf: 'stretch',
		background: 'linear-gradient(180deg, #B42A17 0%, #EB6E5C 55%)',
		marginRight: '2rem',
	},
	loadingSupportText: {
		display: 'block',
		marginTop: '0.75rem',
		color: 'rgba(0, 0, 0, 0.65)',
	},
	typography: {
		opacity: 0.87,
		color: 'black',
	},
	typographyBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2rem',
		flexGrow: '1',
	},
	exampleIdeasBox: {
		padding: '1rem',
		backgroundColor: '#DCEFFE',
		color: 'black',
	},
	listItem: {
		margin: '10px 0',
	},
}
